import {ApiClient} from "../../utils/ApiClient";
import Request from "../../utils/Request";
import {api_version} from "../../settings";

export default class Subscription extends ApiClient {
    static resourceName = "subscriptions";

    static validateCoupon(data) {
        return Request.post(`${api_version}/validate-coupon`, data);
    }
}
